import { render } from "./PortfolioNavbar.vue?vue&type=template&id=2be47f4c"
import script from "./PortfolioNavbar.vue?vue&type=script&lang=js"
export * from "./PortfolioNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__